import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  woReportSubmissionCreateRequest,
  woReportSubmissionCreateSuccess,
  woReportSubmissionCreateFailure,
} = createActions({
  WO_REPORT_SUBMISSION_CREATE_SUCCESS: json => json,
}, 'WO_REPORT_SUBMISSION_CREATE_REQUEST', 'WO_REPORT_SUBMISSION_CREATE_FAILURE');

export function woReportSubmissionCreate(woReportSubmissionData) {
  return (dispatch) => {
    dispatch(woReportSubmissionCreateRequest());
    return create('wo_report_submission', woReportSubmissionData)
      .then(({ json }) => {
        dispatch(woReportSubmissionCreateSuccess(json));
        return json;
      })
      .catch((error) => {
        dispatch(woReportSubmissionCreateFailure(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/wo_report_submissions.js